<template>
  <v-dialog :value="isModalActive" max-width="440" persistent>
    <v-card
      id="welcome-modal"
      class="pb-5"
      :color="$vuetify.theme.dark ? 'dark_backgroundDarkBlue' : undefined"
    >
      <div class="mt-0 pt-1 px-6 pr-8">
        <div class="items-flex justify-between mt-4 mr-1">
          <div>
            <language-selector />
          </div>
          <div>
            <a
              :class="{
                'darkTextGrey--text': !$vuetify.theme.dark,
                'dark_Textgrey--text': $vuetify.theme.dark,
              }"
              class="welcome-logout"
              @click="logout"
            >
              {{ $t('common.logout') }}
            </a>
          </div>
        </div>

        <div v-if="step === 'complete'" id="welcome-modal-complete" class="mt-8 px-2 pb-3">
          <h1 class="my-2" :class="{ 'white--text': $vuetify.theme.dark }">
            {{ $t('views.welcomeModal.title') }}
          </h1>
          <!-- <div class="my-3 welcome-modal-complete-text">
            {{ $t('views.welcomeModal.complete') }}
          </div> -->

          <div class="mt-10 mb-4">
            <div v-if="!showCountryBaseCurrency">
              <div class="welcome-modal-country-base-currency">
                {{ $t('views.welcomeModal.country') }}
                <span class="country-currency">{{ $t(`common.countries.${country}`) }}</span>
                <br />
                {{ $t('views.welcomeModal.currency') }}
                <span class="country-currency">{{ baseCurrency }}</span>
                <br />
                {{ $t('views.welcomeModal.change1') }}
                <a class="links" @click="showCountryBaseCurrency = true">
                  {{ $t('views.welcomeModal.change2') }}
                </a>
              </div>
            </div>
            <div v-else>
              <div class="items-flex align-center">
                <CountrySelector
                  v-model="country"
                  :countries="userAcceptedCountries"
                  :disabled="loading"
                  :label="$t('views.signup.country.label')"
                  :placeholder="$t('views.signup.country.placeholder')"
                  class="small-select"
                  hide-details
                />
                <span class="ml-2">
                  <InfoIcon :size="15" :text="$t('views.signup.country.info')" />
                </span>
              </div>

              <div class="items-flex align-center pt-4">
                <CurrencySelector
                  v-model="baseCurrency"
                  model="user"
                  :disabled="loading"
                  :label="$t('views.signup.baseCurrency.label')"
                  :placeholder="$t('views.signup.baseCurrency.placeholder')"
                  class="small-select"
                />
                <span class="ml-2">
                  <InfoIcon :size="15" :text="$t('views.signup.baseCurrency.info')" />
                </span>
              </div>
            </div>
          </div>

          <!-- <BirthdayPicker v-model="birthday" /> -->

          <!-- <div class="mt-12 pb-2">
            <v-select
              v-model="heard"
              :items="heardItems"
              :label="$t('views.signup.heard.label')"
              :disabled="loading"
              class="medium-select"
              hide-details
            />
          </div> -->

          <!-- <CurrencyInput
                v-model="welcomeAproxPortfolioValue"
                :currency="baseCurrency"
                :label="$t('views.welcomeModal.welcomeAproxPortfolioValue')"
              /> -->

          <div class="referral-code mt-10 pt-6">
            <span v-if="referralCodeAutoCompleted">
              {{ $t('views.welcomeModal.referralCode.title') }}
            </span>
            <div v-else>
              <a @click="addReferralCode = !addReferralCode">
                {{
                  !addReferralCode
                    ? $t('views.welcomeModal.referralCode.show')
                    : $t('views.welcomeModal.referralCode.hide')
                }}
              </a>
              <span class="referral-code-help-icon">
                <InfoIcon
                  :size="15"
                  color="softTextGrey lighten-2"
                  :text="$t('views.welcomeModal.referralCode.help')"
                />
              </span>
            </div>
            <v-text-field
              v-if="addReferralCode"
              v-model="referralCode"
              :placeholder="$t('views.welcomeModal.referralCode.label')"
              name="referralCode"
              type="text"
              :disabled="loading"
              class="pa-0 ma-0 referral-code-input"
              :error-messages="referralCodeError ? $t(`apiErrors.users.invalidReferralCode`) : null"
              :hide-details="!referralCodeError"
            />
          </div>

          <div class="privacy-policy">
            <v-checkbox v-model="privacyPolicyAccepted" hide-details>
              <template v-slot:label>
                <span>
                  {{ $t('views.signup.privacyPolicy.agree1') }}
                </span>
                <a
                  target="_blank"
                  class="links"
                  href="https://www.filios.app/aviso-legal-terminos-y-condiciones"
                  @click.stop
                >
                  {{ $t('views.signup.privacyPolicy.terms') }}
                </a>
                <span>
                  {{ $t('views.signup.privacyPolicy.agree2') }}
                </span>
                <a
                  target="_blank"
                  class="links"
                  href="https://www.filios.app/politica-de-privacidad"
                  @click.stop
                >
                  {{ $t('views.signup.privacyPolicy.privacyPolicy') }}
                </a>
              </template>
            </v-checkbox>
          </div>

          <div class="email-marketing">
            <v-checkbox v-model="emailMarketingAccepted" hide-details class="mt-2">
              <template v-slot:label>
                <span>
                  {{ $t('views.signup.emailMarketing.agree') }}
                </span>
              </template>
            </v-checkbox>
          </div>

          <div class="mt-5">
            <template v-if="validBaseCurrency">
              <v-btn
                color="primary"
                :loading="loading"
                :disabled="submitDisabled"
                class="submit-button elevation-0 mt-2"
                @click="goToContinueStep"
              >
                {{ $t('common.continue') }}
              </v-btn>
            </template>
            <div v-else class="welcome-modal-card-not-base-currency-accepted">
              <v-alert
                :color="$vuetify.theme.dark ? 'dark_backgroundSoftBlue' : 'softInfo'"
                icon="mdi-information"
              >
                {{ $t('views.welcomeModal.notAcceptedBaseCurrency1') }}
                <a href="https://www.filios.app/contacta" target="_blank">
                  {{ $t('views.welcomeModal.notAcceptedBaseCurrency2') }}
                </a>
              </v-alert>
            </div>
          </div>
        </div>
        <WelcomeModalContinue v-if="step === 'continue'" @start="start" />
      </div>
    </v-card>
  </v-dialog>
</template>

<script>
import { find, get } from 'lodash'
import { mapState, mapActions } from 'vuex'
import { welcomed } from '@/lib/api.js'
import { supportedCurrencies } from '@/lib/currencies/currencies.js'
import { userAcceptedCountries } from '@/lib/countries/countries.js'
import CountrySelector from '@/views/components/common/CountrySelector'
import CurrencySelector from '@/views/components/common/CurrencySelector'
import CurrencyInput from '@/views/components/common/CurrencyInput'
// import BirthdayPicker from '@/views/components/core/BirthdayPicker'
import InfoIcon from '@/views/components/common/InfoIcon'
import LanguageSelector from '@/views/components/core/LanguageSelector'
import WelcomeModalContinue from '@/views/components/welcomeModal/WelcomeModalContinue'
import gtag from '@/lib/gtag'

export default {
  components: {
    CountrySelector,
    CurrencySelector,
    CurrencyInput,
    // BirthdayPicker,
    InfoIcon,
    LanguageSelector,
    WelcomeModalContinue,
  },
  data: () => ({
    isModalActive: false,
    step: 'complete',
    loading: false,
    country: 'ES',
    userAcceptedCountries,
    baseCurrency: null,
    // heard: null,
    // birthday: null,
    addReferralCode: false,
    referralCode: null,
    referralCodeAutoCompleted: false,
    referralCodeError: false,
    // welcomeAproxPortfolioValue: null,
    privacyPolicyAccepted: false,
    emailMarketingAccepted: false,
    showCountryBaseCurrency: false,
  }),
  computed: {
    ...mapState(['user']),
    validBaseCurrency() {
      return supportedCurrencies.indexOf(this.baseCurrency) > -1
    },
    submitDisabled() {
      return (
        !this.country ||
        !this.baseCurrency ||
        !this.validBaseCurrency ||
        // !this.heard ||
        // !this.birthday ||
        // (!this.welcomeAproxPortfolioValue && this.welcomeAproxPortfolioValue !== 0) ||
        !this.privacyPolicyAccepted
      )
    },
    // heardItems() {
    //   return ['twitter', 'forum', 'blog', 'google', 'telegram', 'friends', 'youtube', 'other'].map(
    //     (value) => {
    //       return {
    //         text: this.$t(`views.signup.heard.${value}`),
    //         value,
    //       }
    //     }
    //   )
    // },
  },
  watch: {
    user: {
      async handler() {
        if (this.user.status === 'NOT_WELCOMED') {
          this.isModalActive = true

          if (this.user.referralCode) {
            this.referralCodeAutoCompleted = true
            this.referralCode = this.user.referralCode
            this.addReferralCode = true
          }

          gtag.pageview({
            pagePath: `/welcome`,
            pageTitle: `welcome`,
            pageContentGroup: 'modal',
          })
        }
      },
      immediate: true,
    },
    country: {
      async handler() {
        if (this.country) {
          const country = find(userAcceptedCountries, { countryCode: this.country })
          this.$set(this, 'baseCurrency', country.currencyCode)
        }
      },
      immediate: true,
    },
    addReferralCode: {
      handler() {
        if (!this.addReferralCode) this.$set(this, 'referralCode', undefined)
      },
    },
    referralCode: {
      handler() {
        if (this.referralCode) this.$set(this, 'referralCode', this.referralCode.toUpperCase())
      },
    },
  },
  methods: {
    ...mapActions({
      updateUsersInfo: 'UPDATE_USERS_INFO',
      logout: 'LOGOUT',
    }),
    closeModal() {
      this.isModalActive = false
    },
    async goToContinueStep() {
      try {
        this.loading = true

        await welcomed({
          uid: this.user.uid,
          data: {
            country: this.country,
            baseCurrency: this.baseCurrency,
            // birthday: this.birthday,
            // heard: this.heard,
            referralCode: this.referralCode || undefined,
            // welcomeAproxPortfolioValue: this.welcomeAproxPortfolioValue,
            privacyPolicyAccepted: this.privacyPolicyAccepted,
            emailMarketingAccepted: this.emailMarketingAccepted,
          },
        })
        await this.updateUsersInfo()

        this.step = 'continue'

        gtag.pageview({
          pagePath: `/welcome/continue`,
          pageTitle: `welcome|continue`,
          pageContentGroup: 'modal',
        })
      } catch (error) {
        const errorCode = get(error, 'data.name', null)
        if (errorCode === 'users.invalidReferralCode') {
          this.referralCodeError = true
        } else {
          this.$root.$snackbar.error({ text: this.$t('common.commonError') })
        }
      }
      this.loading = false
    },
    start() {
      this.$router.replace({
        name: 'brokerAccounts',
        query: { open: 'broker' },
      })
      // this.$router.push({ path: 'brokerAccountsd', query: { plan: 'private' }})
      this.closeModal()
    },
  },
}
</script>

<style lang="scss">
#welcome-modal {
  .items-flex {
    display: flex;
    &.align-center {
      align-items: center;
    }
    &.justify-between {
      justify-content: space-between;
    }
  }
  .welcome-logout {
    font-size: 14px;
  }
  .links {
    text-decoration: none;
  }
  .v-input.small-select {
    max-width: 200px;
  }
  .v-input.medium-select {
    max-width: 250px;
  }
  h1 {
    font-size: 22px;
    font-weight: 600;
  }
  .welcome-modal-complete-text {
    font-size: 12px;
  }
  .welcome-modal-country-base-currency {
    font-size: 14px;
    line-height: 1.7;
    font-weight: 400;
    .country-currency {
      font-weight: 600;
      text-transform: uppercase;
    }
  }
  .submit-button {
    width: 100%;
  }

  #welcome-modal-complete {
    .welcome-modal-card-not-base-currency-accepted {
      text-align: left;
    }
  }
  .referral-code {
    font-size: 13px;
    text-align: left;
    a {
      color: #2597fe;
    }
    .referral-code-input {
      max-width: 200px;
    }
    .referral-code-help-icon {
      margin-left: 2px;
      .v-icon {
        margin-bottom: 2px;
      }
    }
  }
  .privacy-policy {
    .v-label {
      display: inline;
    }
  }
}
</style>
